import router from "@/router";
import { GuestPages } from "@/constants/guest.constant";

export function clearToken(): void {
  localStorage.removeItem("token");

  if (!GuestPages.includes(router.currentRoute.name as string))
    router.push({
      name: "login",
    });
}

export function getToken(): string | null {
  const token = localStorage.getItem("token");
  return token;
}

export function setToken(token: string): void {
  localStorage.setItem("token", token);
}
